import { useEffect, useRef, useState } from 'react';
// import ReactDOM from 'react-dom'; // unused
import ModernCard from './ui/ModernCard';
import LoadFormModal from './LoadFormModal';
import AdminModal from './AdminModal';
import { saveFormStateToS3, /* loadFormStateFromS3, */ checkForPushedState } from '../services/formStateS3Service';
import { startActivityTracking, stopActivityTracking, updateCurrentSection, updateReferenceNo } from '../services/userActivityService';

import Step1 from './steps/step1';
import { isAdmin } from '../utils/userUtils';

import Step10 from './steps/step10';
import Step11 from './steps/step11';
import Step12 from './steps/step12';
import Step13 from './steps/step13';
import Step2 from './steps/step2';
import Step3 from './steps/step3';
import Step4 from './steps/step4';
import Step5 from './steps/step5';
import Step6 from './steps/step6';
import Step7 from './steps/step7';
import Step8 from './steps/step8';
import Step9 from './steps/step9';

const WEBHOOK_BASE = 'https://webhook.workflow86.com/webhook/d1bdc974-46fd-4c57-919e-9b401472fe7c';
const WEBHOOK_TOKEN = 'TuQSIV0F0QZd3Jf1cAY7iHl3sCUuwrbdX4d29HgNyhE0lmplF6459cp8kBNAKzIX';
const WEBHOOK_CONFIG = {
      url: `${WEBHOOK_BASE}?token=${WEBHOOK_TOKEN}`
};

// Photo upload configuration
const ModernMultiStepEventForm = ({ authUser, username, externalCurrentStep, onStepClick, onStepValidationChange, onVisitedStepsChange, onCurrentStepChange }) => {

      const ENABLE_BACKEND_POLLING = process.env.REACT_APP_ENABLE_BACKEND_POLLING !== 'false';
      const PRESIGN_GET_API = process.env.REACT_APP_PRESIGN_GET_API || process.env.REACT_APP_API_ENDPOINT || 'https://r3vefztcpc.execute-api.ap-southeast-2.amazonaws.com/default/store-efs-report-photos-in-s3';
      const PHOTO_UPLOAD_CONFIG = { enabled: true, bucket: 'ef-event-shift-report-photostore' };

      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const currentDate = now.toISOString().slice(0, 10);
      const currentTime = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

      // Generate a reference number for new forms when one isn't supplied
      const generateReferenceNo = () => {
            const prefix = 'FOR243.2A-EFS';
            const date = new Date().toISOString().split('T')[0];
            const randomSix = Math.floor(100000 + Math.random() * 900000);
            const randomOne = Math.floor(Math.random() * 10);
            return `${prefix}-${date}-${randomSix}-${randomOne}`;
      };

      const [formId, setFormId] = useState(null);
      const [reportData, setReportData] = useState({
            venue: '',
            eventName: '',
            reportCompletedBy: { firstName: '', lastName: '' },
            position: '',
            reportStarted: currentDate,
            reportStartedTime: currentTime,
            referenceNo: generateReferenceNo()
      });
      const [errors, setErrors] = useState({});
      const [stepValidation, setStepValidation] = useState({});
      const [visitedSteps, setVisitedSteps] = useState(new Set([1]));
      const [currentStep, setCurrentStep] = useState(1);
      const [showSavedFormsModal, setShowSavedFormsModal] = useState(false);
      const [showAdminModal, setShowAdminModal] = useState(false);
      const [isSubmitting, setIsSubmitting] = useState(false);

            // Track attempts per pushed state so we don't repeatedly nag users
            const pushedPromptAttempts = (function() {
                  // store in ref-like closure scoped to this effect
                  const map = {};
                  return {
                        get: (id) => (map[id] || 0),
                        inc: (id) => { map[id] = (map[id] || 0) + 1; return map[id]; },
                        setDone: (id) => { map[id] = Number.POSITIVE_INFINITY; },
                        clear: (id) => { delete map[id]; }
                  };
            })();

            // BroadcastChannel to sync acceptance across tabs (if available)
            const bc = (typeof window !== 'undefined' && 'BroadcastChannel' in window) ? new BroadcastChannel('pushed-accepts') : null;
            if (bc) {
                  bc.onmessage = (ev) => {
                        try {
                              const data = ev && ev.data;
                              if (data && data.pushId) {
                                    pushedPromptAttempts.setDone(data.pushId);
                                    try { localStorage.setItem(`pushedAccepted_${data.pushId}`, '1'); } catch (e) { /* ignore */ }
                              }
                        } catch (e) { /* ignore */ }
                  };
            }

      const [eventData, setEventData] = useState({
            eventDate: currentDate,
            eventTime: currentTime,
            eventDateTime: `${currentDate}T${currentTime}`,
            staffRequested: '',
            staffSignedOn: '',
            generalSummary: ''
      });

      const [ticketingItems, setTicketingItems] = useState([]);
      const [carparkItems, setCarparkItems] = useState([]);
      const [corporateRoomItems, setCorporateRoomItems] = useState([]);
      const [cleaningMaintenanceItems, setCleaningMaintenanceItems] = useState([]);
      const [whsItems, setWhsItems] = useState([]);
      const [otherOperationalItems, setOtherOperationalItems] = useState([]);
      const [incidentItems, setIncidentItems] = useState([]);
      const [additionalTaskingItems, setAdditionalTaskingItems] = useState([]);
      const [serviceComplaintItems, setServiceComplaintItems] = useState([]);
      const [staffFeedbackItems, setStaffFeedbackItems] = useState([]);

      const [signoffData, setSignoffData] = useState({
            priority: '',
            timeOfCompletion: '',
            signature: ''
      });

      const [currentFormData, setCurrentFormData] = useState({
            timeRaised: currentDate,
            timeRaisedHour: currentTime,
            description: '',
            location: '',
            actions: '',
            patronRelocated: false,
            originalSeat: '',
            newSeat: '',
            incidentDateTime: `${currentDate}T${currentTime}`,
            incidentCategory: '',
            incidentDescription: '',
            escalationPoint: '',
            taskDateRaised: currentDate,
            taskDescription: '',
            taskDuration: ''
      });

      // const textareaRefs = useRef({}); // unused
      // Ref used to instruct repeating-table children to commit any open add/edit rows
      const dataTableRef = useRef(null);

      const steps = [
            { id: 1, title: 'Report Details' },
            { id: 2, title: 'Event Information', subtitle: "Provide details about the event and staffing information." },
            { id: 3, title: 'Ticketing Issues', subtitle: "Document any Ticketing issues" },
            { id: 4, title: 'Carparking Issues', subtitle: "Document any Carparking issues" },
            { id: 5, title: 'Corporate Room/Suite Issues', subtitle: "Document any Corporate Room/Suite issues" },
            { id: 6, title: 'Cleaning/Maintenance Issues', subtitle: "Document any Cleaning/Maintenance issues" },
            { id: 7, title: 'WHS Issues', subtitle: "Document any WHS issues" },
            { id: 8, title: 'Other Operational Issues', subtitle: "Document any Other Operational issues" },
            { id: 9, title: 'Incidents', subtitle: "Document any incidents" },
            { id: 10, title: 'Additional Taskings', subtitle: "Document any additional taskings which you were required to perform" },
            { id: 11, title: 'Service Complaints', subtitle: "Document any service complaints raised" },
            { id: 12, title: 'Staff Feedback/Staffing Issues', subtitle: "Document any positive or negative feedback on staff performance" },
            { id: 13, title: 'Signoff', subtitle: "Sign off and submit the report" }
      ];

      // Handle step clicks from external sidebar
      const handleSidebarStepClick = (stepNumber) => {
            // Only allow navigation to visited steps
            if (visitedSteps.has(stepNumber)) {
                  setCurrentStep(stepNumber);
                  setErrors({});
            }
      };

      // Notify parent of validation and visited steps
      useEffect(() => {
            onStepValidationChange?.(stepValidation);
            onVisitedStepsChange?.(visitedSteps);
            onCurrentStepChange?.(currentStep);
      }, [stepValidation, visitedSteps, currentStep, onStepValidationChange, onVisitedStepsChange, onCurrentStepChange]);

      // Handle external step changes
      useEffect(() => {
            if (externalCurrentStep && externalCurrentStep !== currentStep) {
                  setCurrentStep(externalCurrentStep);
            }
      }, [externalCurrentStep, currentStep]);

      // Expose our step click handler to parent
      useEffect(() => {
            if (onStepClick) {
                  onStepClick(handleSidebarStepClick);
            }
      }, [onStepClick, visitedSteps]);

      // User activity tracking for admin presence monitoring
      useEffect(() => {
            if (username && ENABLE_BACKEND_POLLING) {
                  startActivityTracking(username, reportData.referenceNo);
                  return () => stopActivityTracking();
            }
            if (username && !ENABLE_BACKEND_POLLING) {
                  console.debug('[Activity] Backend polling disabled via REACT_APP_ENABLE_BACKEND_POLLING');
            }
      }, [username, reportData.referenceNo]);

      // Helper: robustly clear pushed state on backend with simple retry/backoff
      const retryClearPushedState = async (usernameToClear, pushId = null, attempts = 3) => {
            const payload = Object.assign({ action: 'clearPushedState', username: usernameToClear }, pushId ? { pushId } : {});
            let lastErr = null;
            for (let i = 0; i < attempts; i++) {
                  try {
                        const resp = await fetch(PRESIGN_GET_API, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify(payload),
                        });
                        if (resp.ok) {
                              try {
                                    const body = await resp.json();
                                    return { ok: true, body };
                              } catch (e) {
                                    // treat 2xx as success even if body isn't JSON
                                    return { ok: true };
                              }
                        } else {
                              lastErr = new Error(`HTTP ${resp.status}`);
                        }
                  } catch (e) {
                        lastErr = e;
                  }
                  // backoff
                  await new Promise(r => setTimeout(r, 250 * Math.pow(2, i)));
            }
            return { ok: false, error: lastErr };
      };

      // Poll for admin-pushed form states
      useEffect(() => {
            if (!username || !ENABLE_BACKEND_POLLING) {
                  if (username && !ENABLE_BACKEND_POLLING) console.debug('[Form] Backend polling disabled via REACT_APP_ENABLE_BACKEND_POLLING');
                  return;
            }

            const checkForPush = async () => {
                  try {
                        const result = await checkForPushedState(username);
                        if (result.hasPushed && result.formState) {
                              console.log('[Form] 🔔 Admin pushed form detected!', result.formState);

                              // Build an id for this pushed payload to track attempts and acceptance
                              const pushId = result.pushId || result.pushedAt || result.referenceNo || (result.formState && (result.formState.referenceNo || result.formState.reportData?.referenceNo)) || JSON.stringify(result.formState).slice(0,100);

                              // If already accepted in this browser (localStorage) skip prompting
                              try {
                                    const acceptedKey = `pushedAccepted_${pushId}`;
                                    if (localStorage.getItem(acceptedKey)) {
                                          console.debug('[Form] Push already accepted in this browser (skip):', pushId);
                                          return;
                                    }
                              } catch (e) { /* ignore storage errors */ }

                              // If we've already exhausted attempts for this push, ignore
                              if (pushedPromptAttempts.get(pushId) >= 3) {
                                    console.debug('[Form] Push prompt attempts exhausted for', pushId);
                                    return;
                              }

                              // Normalise shape: pushed may be either a full saved snapshot OR just a formState payload
                              const raw = result.formState;
                              const resolved = raw.formState && !raw.referenceNo && !raw.reportData ? raw.formState : raw; // unwrap if nested

                              // Build a fallback reference number for display
                              const ref = resolved.reportData?.referenceNo || resolved.referenceNo || '(no ref)';

                              const confirmLoad = window.confirm(
                                    `🔔 Admin has pushed a form to you!` +
                                    `\n\nReference: ${ref}` +
                                    (result.pushedAt ? `\nPushed At: ${new Date(result.pushedAt).toLocaleString()}` : '') +
                                    `\n\nLoad this form now? (Your current data will be replaced)`
                              );

                              if (confirmLoad) {
                                    // Adapt partial payloads into the expected shape of loadFormFromMemory
                                    const adapted = {
                                          id: resolved.id || `pushed-${Date.now()}`,
                                          currentStep: resolved.currentStep || 1,
                                          stepValidation: resolved.stepValidation || {},
                                          visitedSteps: resolved.visitedSteps || [1],
                                          reportData: resolved.reportData || resolved.report || {},
                                          eventData: resolved.eventData || {},
                                          ticketingItems: resolved.ticketingItems || resolved.ticketing || [],
                                          carparkItems: resolved.carparkItems || resolved.carparkingItems || [],
                                          corporateRoomItems: resolved.corporateRoomItems || [],
                                          cleaningMaintenanceItems: resolved.cleaningMaintenanceItems || [],
                                          whsItems: resolved.whsItems || [],
                                          otherOperationalItems: resolved.otherOperationalItems || [],
                                          incidentItems: resolved.incidentItems || [],
                                          additionalTaskingItems: resolved.additionalTaskingItems || [],
                                          serviceComplaintItems: resolved.serviceComplaintItems || [],
                                          staffFeedbackItems: resolved.staffFeedbackItems || [],
                                          signoffData: resolved.signoffData || { priority: '', timeOfCompletion: '', signature: '' },
                                          currentFormData: resolved.currentFormData || {}
                                    };
                                    loadFormFromMemory(adapted);
                                    alert(`✅ Form loaded successfully!\n\nReference: ${ref}`);

                                    // Try to clear pushed state on backend with retries; persist acceptance locally if successful
                                    try {
                                          const clearResp = await retryClearPushedState(username, pushId, 3);
                                          if (clearResp.ok) {
                                                try { localStorage.setItem(`pushedAccepted_${pushId}`, '1'); } catch (e) { /* ignore */ }
                                                try { if (bc) bc.postMessage({ pushId }); } catch (e) { /* ignore */ }
                                                pushedPromptAttempts.setDone(pushId);
                                          } else {
                                                // Even if backend clear failed, mark accepted locally to avoid immediate re-prompting in this browser
                                                try { localStorage.setItem(`pushedAccepted_${pushId}`, '1'); } catch (e) { /* ignore */ }
                                                try { if (bc) bc.postMessage({ pushId }); } catch (e) { /* ignore */ }
                                                pushedPromptAttempts.setDone(pushId);
                                                console.warn('[Form] clearPushedState failed after retries:', clearResp.error);
                                          }
                                    } catch (e) {
                                          // Ensure we don't prompt again immediately in this browser
                                          try { localStorage.setItem(`pushedAccepted_${pushId}`, '1'); } catch (e2) { /* ignore */ }
                                          try { if (bc) bc.postMessage({ pushId }); } catch (e2) { /* ignore */ }
                                          pushedPromptAttempts.setDone(pushId);
                                          console.warn('[Form] Unexpected error while clearing pushed state:', e && e.message);
                                    }
                                    return;
                              } else {
                                    // User declined — increment attempts; allow up to 2 more prompts (total 3)
                                    pushedPromptAttempts.inc(pushId);
                                    try { localStorage.setItem(`pushedAttempts_${pushId}`, String(pushedPromptAttempts.get(pushId))); } catch (e) { /* ignore */ }
                                    console.debug('[Form] User declined pushed form prompt (attempt)', pushedPromptAttempts.get(pushId), 'for', pushId);
                              }
                        }
                  } catch (err) {
                        console.error('[Form] Error checking for pushed state:', err);
                  }
            };

            // Check immediately on mount
            checkForPush();

            // Poll every 15 seconds
            const interval = setInterval(checkForPush, 15000);

            return () => {
                  clearInterval(interval);
                  try { if (bc) bc.close(); } catch (e) { /* ignore */ }
            };
      }, [username]);

      // Update current section when step changes
      useEffect(() => {
            if (username && currentStep) {
                  const sectionName = getSectionName(currentStep);
                  updateCurrentSection(sectionName || `Step ${currentStep}`);
            }
      }, [currentStep, username]);

      // Update reference number when it changes
      useEffect(() => {
            if (reportData.referenceNo) {
                  updateReferenceNo(reportData.referenceNo);
            }
      }, [reportData.referenceNo]);

      // Helper function to get section name for S3 path
      const getSectionName = (stepNumber) => {
    const sectionMap = {
        3: 'ticketing',
        4: 'carpark',
        5: 'corporate-rooms',
        6: 'cleaning-maintenance',
        7: 'whs',
        8: 'other-operational',
        9: 'incidents',
        10: 'additional-tasking',
        11: 'service-complaints',
        12: 'staff-feedback'
    };
    return sectionMap[stepNumber] || 'general';
};

      const renderStepContent = () => {
            // Get the default datetime from eventData - this will be passed to all steps after Step 2
            const defaultDateTime = eventData.eventDateTime || `${currentDate}T${currentTime}`;

            // Common props for steps with photo upload (include dataTableRef so parent can request commits)
            const photoUploadProps = PHOTO_UPLOAD_CONFIG.enabled ? {
                  enablePhotoUpload: true,
                  referenceNo: reportData.referenceNo,
                  sectionName: getSectionName(currentStep),
                  dataTableRef
            } : {
                  enablePhotoUpload: false,
                  dataTableRef
            };

            switch (currentStep) {
                  case 1:
                        return (
                              <Step1
                                    reportData={reportData}
                                    handleInputChange={(field, value) => {
                                          if (field.includes('.')) {
                                                const [parent, child] = field.split('.');
                                                setReportData(prev => ({
                                                      ...prev,
                                                      [parent]: { ...prev[parent], [child]: value }
                                                }));
                                          } else {
                                                setReportData(prev => ({ ...prev, [field]: value }));
                                          }
                                          if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
                                    }}
                                    errors={errors}
                                    authUser={authUser}
                                    username={username}
                              />
                        );
                  case 2:
                        return (
                              <Step2
                                    reportData={reportData}
                                    eventData={eventData}
                                    handleInputChange={(field, value) => {
                                          setEventData(prev => ({ ...prev, [field]: value }));
                                          if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
                                    }}
                                    errors={errors}
                              />
                        );
                  case 3:
                        return (
                              <Step3
                                    ticketingItems={ticketingItems}
                                    setTicketingItems={setTicketingItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 4:
                        return (
                              <Step4
                                    carparkItems={carparkItems}
                                    setCarparkItems={setCarparkItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 5:
                        return (
                              <Step5
                                    corporateRoomItems={corporateRoomItems}
                                    setCorporateRoomItems={setCorporateRoomItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 6:
                        return (
                              <Step6
                                    cleaningMaintenanceItems={cleaningMaintenanceItems}
                                    setCleaningMaintenanceItems={setCleaningMaintenanceItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 7:
                        return (
                              <Step7
                                    whsItems={whsItems}
                                    setWhsItems={setWhsItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 8:
                        return (
                              <Step8
                                    otherOperationalItems={otherOperationalItems}
                                    setOtherOperationalItems={setOtherOperationalItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 9:
                        return (
                              <Step9
                                    incidentItems={incidentItems}
                                    setIncidentItems={setIncidentItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 10:
                        return (
                              <Step10
                                    additionalTaskingItems={additionalTaskingItems}
                                    setAdditionalTaskingItems={setAdditionalTaskingItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 11:
                        return (
                              <Step11
                                    serviceComplaintItems={serviceComplaintItems}
                                    setServiceComplaintItems={setServiceComplaintItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 12:
                        return (
                              <Step12
                                    staffFeedbackItems={staffFeedbackItems}
                                    setStaffFeedbackItems={setStaffFeedbackItems}
                                    defaultDateTime={defaultDateTime}
                                    {...photoUploadProps}
                              />
                        );
                  case 13:
                        return (
                              <Step13
                                    username={username}
                                    signoffData={signoffData}
                                    handleSignoffChange={data => {
                                          setSignoffData(data);
                                          // Clear errors for fields that now have values
                                          const updatedErrors = { ...errors };
                                          if (data.priority && updatedErrors.priority) delete updatedErrors.priority;
                                          if (data.timeOfCompletion && updatedErrors.timeOfCompletion) delete updatedErrors.timeOfCompletion;
                                          if (data.signature && updatedErrors.signature) delete updatedErrors.signature;
                                          if (Object.keys(updatedErrors).length !== Object.keys(errors).length) {
                                                setErrors(updatedErrors);
                                          }
                                    }}
                                    errors={errors}
                              />
                        );
                  default:
                        return null;
            }
      };

      // Save form to S3
      const [isSaving, setIsSaving] = useState(false);

      const buildFormDataToSave = (sectionName = null) => ({
            id: formId || Date.now().toString(),
            createdAt: formId
                  ? JSON.parse(localStorage.getItem(`savedEventForms_${username}`) || '[]')
                        .find(f => f.id === formId)?.createdAt || new Date().toISOString()
                  : new Date().toISOString(),
            lastModified: new Date().toISOString(),
            // Section the save was taken from (eg: 'ticketing', 'general' etc.)
            sectionName: sectionName || getSectionName(currentStep),
            currentStep,
            stepValidation,
            visitedSteps: Array.from(visitedSteps),
            reportData,
            eventData,
            ticketingItems,
            carparkItems,
            corporateRoomItems,
            cleaningMaintenanceItems,
            whsItems,
            otherOperationalItems,
            incidentItems,
            additionalTaskingItems,
            serviceComplaintItems,
            staffFeedbackItems,
            signoffData,
            currentFormData
      });

      const saveFormStateBackground = (formData) => {
            // Fire-and-forget save to S3; non-blocking. Errors are logged but do not interrupt UI flow.
            if (!username || !reportData.referenceNo || !formData) {
                  console.debug('[FormState] Background save skipped - missing data');
                  return;
            }
            setIsSaving(true);
            // include sectionName if provided on the data object, otherwise service will set one
            saveFormStateToS3(username, reportData.referenceNo, formData)
                  .then(res => {
                        console.log('[FormState] Background save completed:', res);
                        // Optionally update local cache or UI here
                  })
                  .catch(err => {
                        console.error('[FormState] Background save failed:', err);
                        // don't surface error to user in blocking way
                  })
                  .finally(() => setIsSaving(false));
      };

      const saveFormToMemory = () => {
            if (!username) {
                  alert('Please log in to save forms');
                  return;
            }
            if (!reportData.referenceNo) {
                  alert('Reference number is required to save form');
                  return;
            }

            const formDataToSave = buildFormDataToSave(getSectionName(currentStep));
            if (!formId) setFormId(formDataToSave.id);

            // Non-blocking save
            saveFormStateBackground(formDataToSave);
      };

      // Load form from S3
      const loadFormFromMemory = (saved) => {
            setFormId(saved.id);
            setCurrentStep(saved.currentStep);
            setStepValidation(saved.stepValidation);
            setVisitedSteps(new Set(saved.visitedSteps));
            setReportData(saved.reportData);
            setEventData(saved.eventData);
            setTicketingItems(saved.ticketingItems || []);
            setCarparkItems(saved.carparkItems || []);
            setCorporateRoomItems(saved.corporateRoomItems || []);
            setCleaningMaintenanceItems(saved.cleaningMaintenanceItems || []);
            setWhsItems(saved.whsItems || []);
            setOtherOperationalItems(saved.otherOperationalItems || []);
            setIncidentItems(saved.incidentItems || []);
            setAdditionalTaskingItems(saved.additionalTaskingItems || []);
            setServiceComplaintItems(saved.serviceComplaintItems || []);
            setStaffFeedbackItems(saved.staffFeedbackItems || []);
            setSignoffData(saved.signoffData || { priority: '', timeOfCompletion: '', signature: '' });
            setCurrentFormData(saved.currentFormData || {});
            setShowSavedFormsModal(false);
            // Trigger background hydration of photos referenced in the saved snapshot
            if (saved && saved._photoIndex) {
                  // Fire-and-forget
                  (async () => {
                        try {
                              await hydratePhotosFromIndex(saved._photoIndex);
                        } catch (e) {
                              console.warn('[FormHydrate] Photo hydration failed (non-fatal):', e && e.message);
                        }
                  })();
            }
      };

      // Map section keys (from _photoIndex) to state setters and current values
      const SECTION_MAP = {
            ticketing: { getter: () => ticketingItems, setter: setTicketingItems },
            carpark: { getter: () => carparkItems, setter: setCarparkItems },
            corporateRoom: { getter: () => corporateRoomItems, setter: setCorporateRoomItems },
            cleaningMaintenance: { getter: () => cleaningMaintenanceItems, setter: setCleaningMaintenanceItems },
            whs: { getter: () => whsItems, setter: setWhsItems },
            otherOperational: { getter: () => otherOperationalItems, setter: setOtherOperationalItems },
            // Accept both singular/plural and different key styles used across save/load logic
            incident: { getter: () => incidentItems, setter: setIncidentItems },
            incidents: { getter: () => incidentItems, setter: setIncidentItems },
            additionalTasking: { getter: () => additionalTaskingItems, setter: setAdditionalTaskingItems },
            serviceComplaint: { getter: () => serviceComplaintItems, setter: setServiceComplaintItems },
            'service-complaints': { getter: () => serviceComplaintItems, setter: setServiceComplaintItems },
            staffFeedback: { getter: () => staffFeedbackItems, setter: setStaffFeedbackItems },
            'staff-feedback': { getter: () => staffFeedbackItems, setter: setStaffFeedbackItems }
      };

      // Attempt to hydrate photos referenced in _photoIndex.
      // For each entry we try a lightweight HEAD request against an available s3Url
      // and, if reachable, attach previewUrl/s3Url/etag to the corresponding item/photo
      // in-memory so the UI can display thumbnails quickly.
      const hydratePhotosFromIndex = async (photoIndex) => {
            if (!photoIndex || typeof photoIndex !== 'object') return;

            const entries = Object.entries(photoIndex);
            const apiEndpoint = PRESIGN_GET_API;

            // Prepare per-section state buffers so we never mix photos between sections
            const sectionStateMap = {};
            for (const [k, v] of Object.entries(SECTION_MAP)) {
                  const currentItems = v.getter() || [];
                  sectionStateMap[k] = {
                        mapEntry: v,
                        currentItems,
                        newItems: currentItems.map(it => ({ ...it })),
                        updated: false
                  };
            }

            // Global ordered list of pending presign requests (keeps order for response mapping)
            const pendingRequestsGlobal = [];

            // First pass: try to hydrate from any reachable URL and queue any missing keys
            for (const [sectionKey, photos] of entries) {
                  const stateEntry = sectionStateMap[sectionKey];
                  if (!stateEntry) continue; // unknown section key - skip

                  for (const p of photos) {
                        try {
                              let url = p.s3Url || p.fileUrl || (p.bucket && p.s3Key ? `https://${p.bucket}.s3.amazonaws.com/${p.s3Key}` : null);
                              let reachable = false;

                              if (url) {
                                    try {
                                          const head = await fetch(url, { method: 'HEAD', mode: 'cors' });
                                          reachable = head.ok;
                                    } catch (e) {
                                          try {
                                                const rangeResp = await fetch(url, { method: 'GET', headers: { Range: 'bytes=0-10' }, mode: 'cors' });
                                                reachable = rangeResp.ok;
                                          } catch (e2) {
                                                reachable = false;
                                          }
                                    }
                              }

                              const itemIdx = (p.itemIndex != null ? Number(p.itemIndex) : null);
                              const photoIdx = (p.photoIndex != null ? Number(p.photoIndex) : null);

                              if (!reachable && p.s3Key) {
                                    pendingRequestsGlobal.push({ sectionKey, s3Key: p.s3Key, bucket: p.bucket || null, itemIndex: itemIdx, photoIndex: photoIdx });
                                    continue;
                              }

                              if (reachable && itemIdx && photoIdx) {
                                    const targetItemIndex = Math.max(0, itemIdx - 1);
                                    if (!stateEntry.newItems[targetItemIndex]) continue;
                                    const targetItem = { ...stateEntry.newItems[targetItemIndex] };
                                    const photosArr = Array.isArray(targetItem.photos) ? [...targetItem.photos] : [];
                                    while (photosArr.length < photoIdx) photosArr.push({});
                                    const existing = { ...(photosArr[photoIdx - 1] || {}) };
                                    existing.s3Key = existing.s3Key || p.s3Key;
                                    existing.s3Url = existing.s3Url || url;
                                    existing.previewUrl = existing.previewUrl || url;
                                    existing.bucket = existing.bucket || p.bucket;
                                    existing.uploadedAt = existing.uploadedAt || p.uploadedAt;
                                    photosArr[photoIdx - 1] = existing;
                                    targetItem.photos = photosArr;
                                    stateEntry.newItems[targetItemIndex] = targetItem;
                                    stateEntry.updated = true;
                                    sectionStateMap[sectionKey] = stateEntry;
                              }
                        } catch (e) {
                              console.warn('[FormHydrate] Skipping photo hydration for', p && p.s3Key, e && e.message);
                        }
                  }
            }

            // Second pass: request presigned GETs for any pending keys in a single batch
            if (pendingRequestsGlobal.length > 0) {
                  try {
                        const keys = pendingRequestsGlobal.map(p => ({ s3Key: p.s3Key, bucket: p.bucket }));
                        const resp = await fetch(apiEndpoint, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ requestType: 'getPresignedGets', keys }),
                        });
                        if (resp.ok) {
                              const body = await resp.json();
                              if (Array.isArray(body.presigned)) {
                                    for (let i = 0; i < body.presigned.length; i++) {
                                          const r = body.presigned[i];
                                          const req = pendingRequestsGlobal[i];
                                          if (!req) continue;
                                          const secKey = req.sectionKey;
                                          const stateEntry = sectionStateMap[secKey];
                                          if (r && r.success && r.url && stateEntry) {
                                                const url = r.url;
                                                const targetItemIndex = Math.max(0, (req.itemIndex || 1) - 1);
                                                if (!stateEntry.newItems[targetItemIndex]) continue;
                                                const targetItem = { ...stateEntry.newItems[targetItemIndex] };
                                                const photosArr = Array.isArray(targetItem.photos) ? [...targetItem.photos] : [];
                                                const photoIdx = Math.max(1, req.photoIndex || 1);
                                                while (photosArr.length < photoIdx) photosArr.push({});
                                                const existing = { ...(photosArr[photoIdx - 1] || {}) };
                                                existing.s3Key = existing.s3Key || req.s3Key;
                                                existing.s3Url = existing.s3Url || url;
                                                existing.previewUrl = existing.previewUrl || url;
                                                existing.bucket = existing.bucket || req.bucket;
                                                photosArr[photoIdx - 1] = existing;
                                                targetItem.photos = photosArr;
                                                stateEntry.newItems[targetItemIndex] = targetItem;
                                                stateEntry.updated = true;
                                                sectionStateMap[secKey] = stateEntry;
                                          }
                                    }
                              }
                        }
                  } catch (e) {
                        console.warn('hydratePhotosFromIndex: presigned GETs failed', e);
                  }
            }

            // Commit updated sections back to their respective state setters
            for (const [secKey, secState] of Object.entries(sectionStateMap)) {
                  if (secState && secState.updated && secState.mapEntry && typeof secState.mapEntry.setter === 'function') {
                        try {
                              secState.mapEntry.setter(secState.newItems);
                        } catch (e) {
                              console.warn('[FormHydrate] Failed to set hydrated items for', secKey, e && e.message);
                        }
                  }
            }
      };

      // Validate a given step
      const validateStep = (stepNumber) => {
            switch (stepNumber) {
                  case 1:
                        return !!(
                              reportData.venue &&
                              reportData.eventName &&
                              reportData.reportCompletedBy.firstName &&
                              reportData.reportCompletedBy.lastName &&
                              reportData.position &&
                              reportData.reportStarted &&
                              reportData.reportStartedTime
                        );
                  case 2:
                        return !!(
                              (eventData.eventDateTime || (eventData.eventDate && eventData.eventTime)) &&
                              eventData.staffRequested &&
                              eventData.staffSignedOn &&
                              eventData.generalSummary
                        );
                  case 13:
                        // Validate signature has actual content (empty canvas data URLs are much shorter)
                        // A typical empty canvas is ~200 chars, actual signatures are >1000 chars
                        const hasValidSignature = signoffData.signature &&
                              signoffData.signature.length > 500 &&
                              signoffData.signature.startsWith('data:image/');
                        return !!(
                              signoffData.priority &&
                              signoffData.timeOfCompletion &&
                              hasValidSignature
                        );
                  default:
                        return true;
            }
      };

      // Track visited steps
      useEffect(() => {
            const newVisited = new Set([...visitedSteps, currentStep]);
            if (newVisited.size !== visitedSteps.size) {
                  setVisitedSteps(newVisited);
            }
      }, [currentStep, visitedSteps]);

      // Move to next step
      const handleNext = async () => {
            // Auto-commit any open repeating-table row. If commit fails (validation), block navigation.
            try {
                  if (dataTableRef.current && typeof dataTableRef.current.tryCommit === 'function') {
                        const ok = await dataTableRef.current.tryCommit();
                        if (!ok) {
                              // validation error in table - do not navigate
                              return;
                        }
                  }
            } catch (e) {
                  console.warn('Error while auto-committing table before Next:', e);
            }

            if (validateStep(currentStep)) {
                  setStepValidation(prev => ({ ...prev, [currentStep]: true }));
                  // Build snapshot and trigger background save (non-blocking)
                        try {
                              const snapshot = buildFormDataToSave(getSectionName(currentStep));
                              saveFormStateBackground(snapshot);
                        } catch (e) {
                              console.debug('Background save snapshot failed:', e);
                        }
                  setCurrentStep(s => Math.min(s + 1, steps.length));
                  setErrors({});
            } else {
                  setStepValidation(prev => ({ ...prev, [currentStep]: false }));
                  const fieldErrors = {};
                  if (currentStep === 1) {
                        if (!reportData.venue) fieldErrors.venue = 'Venue is required';
                        if (!reportData.eventName) fieldErrors.eventName = 'Event name is required';
                        if (!reportData.reportCompletedBy.firstName) fieldErrors['reportCompletedBy.firstName'] = 'First name is required';
                        if (!reportData.reportCompletedBy.lastName) fieldErrors['reportCompletedBy.lastName'] = 'Last name is required';
                        if (!reportData.position) fieldErrors.position = 'Position is required';
                        if (!reportData.reportStarted) fieldErrors.reportStarted = 'Report started date is required';
                  } else if (currentStep === 2) {
                        if (!eventData.eventDateTime && !eventData.eventDate) fieldErrors.eventDateTime = 'Event date and time is required';
                        if (!eventData.staffRequested) fieldErrors.staffRequested = 'Staff requested is required';
                        if (!eventData.staffSignedOn) fieldErrors.staffSignedOn = 'Staff signed on is required';
                        if (!eventData.generalSummary) fieldErrors.generalSummary = 'General summary is required';
                  } else if (currentStep === 13) {
                        if (!signoffData.priority) fieldErrors.priority = 'Priority is required';
                        if (!signoffData.timeOfCompletion) fieldErrors.timeOfCompletion = 'Time of completion is required';
                        if (!signoffData.signature) fieldErrors.signature = 'Signature is required';
                  }
                  setErrors(fieldErrors);
            }
      };

      // Move to previous step
      const handlePrevious = async () => {
            // Auto-commit any open repeating-table row before navigating back.
            try {
                  if (dataTableRef.current && typeof dataTableRef.current.tryCommit === 'function') {
                        const ok = await dataTableRef.current.tryCommit();
                        if (!ok) {
                              // validation error in table - do not navigate
                              return;
                        }
                  }
            } catch (e) {
                  console.warn('Error while auto-committing table before Previous:', e);
            }

            setCurrentStep(s => Math.max(s - 1, 1));
            setErrors({});
      };

      // Function to extract photos from all sections for submission
      const extractAllPhotos = () => {
            const allPhotos = {};
            const photoSummary = {
                  totalSections: 0,
                  totalPhotos: 0,
                  sectionsWithPhotos: [],
                  totalFileSize: 0
            };

            const sections = [
                  { items: ticketingItems, name: 'ticketing' },
                  { items: carparkItems, name: 'carpark' },
                  { items: corporateRoomItems, name: 'corporateRooms' },
                  { items: cleaningMaintenanceItems, name: 'cleaningMaintenance' },
                  { items: whsItems, name: 'whs' },
                  { items: otherOperationalItems, name: 'otherOperational' },
                  { items: incidentItems, name: 'incidents' },
                  { items: additionalTaskingItems, name: 'additionalTasking' },
                  { items: serviceComplaintItems, name: 'serviceComplaints' },
                  { items: staffFeedbackItems, name: 'staffFeedback' }
            ];

            sections.forEach(section => {
                  const sectionPhotos = [];
                  section.items.forEach((item, itemIndex) => {
                        if (item.photos && item.photos.length > 0) {
                              item.photos.forEach((photo, photoIndex) => {
                                    sectionPhotos.push({
                                          // Complete photo metadata for production
                                          id: photo.id,
                                          filename: photo.filename,
                                          s3Key: photo.s3Key,
                                          s3Url: photo.s3Url,
                                          bucket: photo.bucket || 'ef-event-shift-report-photostore',
                                          fileSize: photo.fileSize,
                                          fileType: photo.fileType,
                                          fileExtension: photo.fileExtension,
                                          uploadedAt: photo.uploadedAt,
                                          etag: photo.etag,
                                          sectionName: photo.sectionName,
                                          referenceNo: photo.referenceNo,
                                          itemIndex,
                                          photoIndex,
                                          itemId: item.id
                                    });

                                    // Add to total file size
                                    photoSummary.totalFileSize += photo.fileSize || 0;
                              });
                        }
                  });

                  if (sectionPhotos.length > 0) {
                        allPhotos[section.name] = {
                              count: sectionPhotos.length,
                              photos: sectionPhotos,
                              sectionDisplayName: section.name.charAt(0).toUpperCase() + section.name.slice(1),
                              totalSectionFileSize: sectionPhotos.reduce((sum, photo) => sum + (photo.fileSize || 0), 0)
                        };

                        photoSummary.totalSections++;
                        photoSummary.totalPhotos += sectionPhotos.length;
                        photoSummary.sectionsWithPhotos.push(section.name);
                  }
            });

            return {
                  sections: allPhotos,
                  summary: photoSummary
            };
      };

      // Enhanced handleSubmit function with photo data
      const handleSubmit = () => {
            if (!validateStep(13)) {
                  setStepValidation(prev => ({ ...prev, 13: false }));
                  const errs = {};
                  if (!signoffData.priority) errs.priority = 'Priority is required';
                  if (!signoffData.timeOfCompletion) errs.timeOfCompletion = 'Time of completion is required';

                  // Enhanced signature validation with helpful error messages
                  if (!signoffData.signature) {
                        errs.signature = 'Signature is required';
                  } else if (signoffData.signature.length <= 500) {
                        errs.signature = 'Please provide a valid signature (the current signature appears to be empty or incomplete)';
                  } else if (!signoffData.signature.startsWith('data:image/')) {
                        errs.signature = 'Signature data is invalid. Please draw your signature again.';
                  }

                  setErrors(errs);
                  return;
            }

            setStepValidation(prev => ({ ...prev, 13: true }));
            setIsSubmitting(true);

            // Extract all photos from all sections
            const allPhotos = extractAllPhotos();

            // Note: Removed unused createNilEntry helper to satisfy eslint no-unused-vars

            // Process sections - use actual data if exists, otherwise inject Nil entry
            const processedTicketingItems = ticketingItems.length > 0 
                  ? ticketingItems 
                  : [{ timeRaised: 'Nil', description: '-', patronRelocated: '-', originalSeat: '-', newSeat: '-', actionsToResolve: '-' }];
            
            const processedCarparkItems = carparkItems.length > 0 
                  ? carparkItems 
                  : [{ timeRaised: 'Nil', description: '-', location: '-', vehiclesAffected: '-', actionsTaken: '-' }];
            
            const processedCorporateRoomItems = corporateRoomItems.length > 0 
                  ? corporateRoomItems 
                  : [{ dateRaised: 'Nil', description: '-', location: '-', guestsAffected: '-', actionsTaken: '-' }];
            
            const processedCleaningMaintenanceItems = cleaningMaintenanceItems.length > 0 
                  ? cleaningMaintenanceItems 
                  : [{ timeRaised: 'Nil', issueType: '-', location: '-', description: '-', safetyHazard: '-', safetyMeasures: '-', actionsTaken: '-' }];
            
            const processedWhsItems = whsItems.length > 0 
                  ? whsItems 
                  : [{ timeRaised: 'Nil', whsCategory: '-', location: '-', description: '-', severityLevel: '-', numberOfEmployees: '-', employeeDetails: '-', actionTaken: '-' }];
            
            const processedOtherOperationalItems = otherOperationalItems.length > 0 
                  ? otherOperationalItems 
                  : [{ timeRaised: 'Nil', operationalCategory: '-', description: '-', impactLevel: '-', actionsTaken: '-' }];
            
            const processedIncidentItems = incidentItems.length > 0 
                  ? incidentItems 
                  : [{ timeRaised: 'Nil', location: '-', incidentCategory: '-', customIncidentCategory: '-', incidentSeverity: '-', actionsTaken: '-' }];
            
            const processedAdditionalTaskingItems = additionalTaskingItems.length > 0 
                  ? additionalTaskingItems 
                  : [{ requestTime: 'Nil', taskDescription: '-', taskRequestedBy: '-', taskDuration: '-', taskCompleted: '-', completionNotes: '-' }];
            
            const processedServiceComplaintItems = serviceComplaintItems.length > 0 
                  ? serviceComplaintItems 
                  : [{ complaintTime: 'Nil', complaintCategory: '-', customComplaintCategory: '-', complainantDetails: '-', complaintDescription: '-', complaintSeverity: '-', immediateResponse: '-', followUpRequired: '-', followUpDetails: '-' }];
            
            const processedStaffFeedbackItems = staffFeedbackItems.length > 0 
                  ? staffFeedbackItems 
                  : [{ feedbackTime: 'Nil', feedbackCategory: '-', staffMemberName: '-', staffMemberDetails: '-', performanceType: '-', performanceDescription: '-', otherStaffingIssue: '-' }];

            // Create the structured payload first
            const structuredPayload = {
                  metadata: {
                        formId,
                        submissionTimestamp: new Date().toISOString(),
                        formVersion: '1.0',
                        submittedBy: `${reportData.reportCompletedBy.firstName} ${reportData.reportCompletedBy.lastName}`,
                        referenceNumber: reportData.referenceNo,
                        hasPhotos: allPhotos.summary.totalPhotos > 0,
                        totalPhotoCount: allPhotos.summary.totalPhotos
                  },
                  reportData: {
                        ...reportData,
                        reportCompletedBy: {
                              ...reportData.reportCompletedBy,
                              fullName: `${reportData.reportCompletedBy.firstName} ${reportData.reportCompletedBy.lastName}`
                        }
                  },
                  eventData,
                  repeatingTableData: {
                        ticketing: {
                              items: processedTicketingItems,
                              count: ticketingItems.length, // Original count
                              hasEntries: ticketingItems.length > 0 ? "Yes" : "No",
                              isNilEntry: ticketingItems.length === 0 ? "Yes" : "No"
                        },
                        carpark: {
                              items: processedCarparkItems,
                              count: carparkItems.length, // Original count
                              hasEntries: carparkItems.length > 0 ? "Yes" : "No",
                              isNilEntry: carparkItems.length === 0 ? "Yes" : "No"
                        },
                        corporateRooms: {
                              items: processedCorporateRoomItems,
                              count: corporateRoomItems.length, // Original count
                              hasEntries: corporateRoomItems.length > 0 ? "Yes" : "No",
                              isNilEntry: corporateRoomItems.length === 0 ? "Yes" : "No"
                        },
                        cleaningMaintenance: {
                              items: processedCleaningMaintenanceItems,
                              count: cleaningMaintenanceItems.length, // Original count
                              hasEntries: cleaningMaintenanceItems.length > 0 ? "Yes" : "No",
                              isNilEntry: cleaningMaintenanceItems.length === 0 ? "Yes" : "No"
                        },
                        whs: {
                              items: processedWhsItems,
                              count: whsItems.length, // Original count
                              hasEntries: whsItems.length > 0 ? "Yes" : "No",
                              isNilEntry: whsItems.length === 0 ? "Yes" : "No"
                        },
                        otherOperational: {
                              items: processedOtherOperationalItems,
                              count: otherOperationalItems.length, // Original count
                              hasEntries: otherOperationalItems.length > 0 ? "Yes" : "No",
                              isNilEntry: otherOperationalItems.length === 0 ? "Yes" : "No"
                        },
                        incidents: {
                              items: processedIncidentItems,
                              count: incidentItems.length, // Original count
                              hasEntries: incidentItems.length > 0 ? "Yes" : "No",
                              isNilEntry: incidentItems.length === 0 ? "Yes" : "No"
                        },
                        additionalTasking: {
                              items: processedAdditionalTaskingItems,
                              count: additionalTaskingItems.length, // Original count
                              hasEntries: additionalTaskingItems.length > 0 ? "Yes" : "No",
                              isNilEntry: additionalTaskingItems.length === 0 ? "Yes" : "No"
                        },
                        serviceComplaints: {
                              items: processedServiceComplaintItems,
                              count: serviceComplaintItems.length, // Original count
                              hasEntries: serviceComplaintItems.length > 0 ? "Yes" : "No",
                              isNilEntry: serviceComplaintItems.length === 0 ? "Yes" : "No"
                        },
                        staffFeedback: {
                              items: processedStaffFeedbackItems,
                              count: staffFeedbackItems.length, // Original count
                              hasEntries: staffFeedbackItems.length > 0 ? "Yes" : "No",
                              isNilEntry: staffFeedbackItems.length === 0 ? "Yes" : "No"
                        }
                  },
                  // Photo data section - PRODUCTION COMPLETE
                  photoData: {
                        enabled: PHOTO_UPLOAD_CONFIG.enabled,
                        s3Bucket: 'ef-event-shift-report-photostore',
                        sections: allPhotos.sections,
                        summary: {
                              totalSections: allPhotos.summary.totalSections,
                              totalPhotos: allPhotos.summary.totalPhotos,
                              sectionsWithPhotos: allPhotos.summary.sectionsWithPhotos,
                              totalFileSize: allPhotos.summary.totalFileSize,
                              totalFileSizeMB: (allPhotos.summary.totalFileSize / (1024 * 1024)).toFixed(2)
                        },
                        uploadDetails: {
                              apiEndpoint: 'https://r3vefztcpc.execute-api.ap-southeast-2.amazonaws.com/default',
                              requestType: 'uploadEFSEventShiftPhotos',
                              uploadTimestamp: new Date().toISOString(),
                              maxPhotosPerSection: 5
                        }
                  },
                  signoffData: {
                        ...signoffData,
                        signedOffBy: `${reportData.reportCompletedBy.firstName} ${reportData.reportCompletedBy.lastName}`,
                        signedOffAt: new Date().toISOString(),
                        reportStatus: 'Completed'
                  },
                  legacyFormData: currentFormData
            };

            // Transform the payload but keep it structured (let the parser do the flattening)
            const transformedPayload = transformPayloadData(structuredPayload);

            console.log('Final structured payload with photos:', transformedPayload);

            // Track in-flight submission
            if (username) {
                  const inflightKey = `inflightSubmissions_${username}`;
                  const inflight = JSON.parse(localStorage.getItem(inflightKey) || '[]');
                  inflight.push({
                        id: formId || Date.now().toString(),
                        referenceNo: reportData.referenceNo,
                        payload: transformedPayload,
                        startedAt: new Date().toISOString(),
                        status: 'sending'
                  });
                  localStorage.setItem(inflightKey, JSON.stringify(inflight));
            }

            // Submit the structured payload
            fetch(WEBHOOK_CONFIG.url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(transformedPayload)
            })
                  .then(response => {
                        return response.text().then(text => {
                              if (!response.ok) {
                                    throw new Error(`Failed: ${response.status} ${response.statusText} - ${text}`);
                              }
                              return text;
                        });
                  })
                  .then(() => {
                        if (username) {
                              // Save to submitted forms archive
                              const submittedKey = `submittedEventForms_${username}`;
                              const submittedForms = JSON.parse(localStorage.getItem(submittedKey) || '[]');
                              submittedForms.push({
                                    ...transformedPayload,
                                    submittedAt: new Date().toISOString(),
                                    referenceNo: reportData.referenceNo
                              });
                              localStorage.setItem(submittedKey, JSON.stringify(submittedForms));

                              // Remove from in-flight submissions
                              const inflightKey = `inflightSubmissions_${username}`;
                              const inflight = JSON.parse(localStorage.getItem(inflightKey) || '[]');
                              localStorage.setItem(inflightKey, JSON.stringify(inflight.filter(f => f.id !== formId)));

                              // Remove from draft/saved forms
                              if (formId) {
                                    const storageKey = `savedEventForms_${username}`;
                                    const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
                                    localStorage.setItem(storageKey, JSON.stringify(saved.filter(f => f.id !== formId)));
                              }
                        }
                        alert(`Report submitted successfully! Reference: ${reportData.referenceNo}`);
                  })
                  .catch(error => {
                        console.error(error);
                        // Keep in-flight record on failure
                        if (username) {
                              const inflightKey = `inflightSubmissions_${username}`;
                              const inflight = JSON.parse(localStorage.getItem(inflightKey) || '[]');
                              const failedSubmission = inflight.find(f => f.id === formId);
                              if (failedSubmission) {
                                    failedSubmission.lastError = error.message;
                                    failedSubmission.lastAttempt = new Date().toISOString();
                                    localStorage.setItem(inflightKey, JSON.stringify(inflight));
                              }
                        }
                        alert(`Submission failed: ${error.message}`);
                  })
                  .finally(() => {
                        setIsSubmitting(false);
                  });
      };

      // Function to transform payload data before sending
      const transformPayloadData = (payload) => {
            // Create a deep copy of the payload to avoid mutating the original
            const transformed = JSON.parse(JSON.stringify(payload));

            // Value mapping dictionary
            const valueMap = {
                  'standard': 'Standard',
                  'immediate': 'Immediate',
                  'critical': 'Critical',
                  'commendation': 'Performance commendation',
                  'performance failure': 'Performance failure'
            };

            // Function to format dates
            const formatDate = (dateString) => {
                  if (!dateString) return dateString;

                  try {
                        const date = new Date(dateString);
                        if (isNaN(date.getTime())) return dateString;

                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();

                        // Check if the dateString includes time component
                        if (dateString.includes('T')) {
                              const hours = String(date.getHours()).padStart(2, '0');
                              const minutes = String(date.getMinutes()).padStart(2, '0');
                              return `${day}/${month}/${year} ${hours}:${minutes}`;
                        } else {
                              return `${day}/${month}/${year}`;
                        }
                  } catch (e) {
                        console.error("Date formatting error:", e);
                        return dateString;
                  }
            };

            // Recursive function to process all values in the object
            const processObject = (obj) => {
                  if (!obj || typeof obj !== 'object') return obj;

                  // Check if it's an array
                  if (Array.isArray(obj)) {
                        return obj.map(item => processObject(item));
                  }

                  // Process object properties
                  const hasNonEmptyValues = Object.values(obj).some(val =>
                        val !== null && val !== undefined && val !== '' &&
                        !(typeof val === 'object' && Object.keys(val).length === 0)
                  );

                  // Process each property
                  for (const key in obj) {
                        // Skip if property doesn't exist or is null/undefined
                        if (!obj.hasOwnProperty(key) || obj[key] === null || obj[key] === undefined) continue;

                        const value = obj[key];

                        // Handle nested objects/arrays
                        if (typeof value === 'object') {
                              obj[key] = processObject(value);
                              continue;
                        }

                        // Handle string values
                        if (typeof value === 'string') {
                              // Check for date format
                              if (/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2})?)?/.test(value)) {
                                    obj[key] = formatDate(value);
                                    continue;
                              }

                              // Check for mapped values
                              if (valueMap[value] !== undefined) {
                                    obj[key] = valueMap[value];
                                    continue;
                              }
                        }

                        // Handle boolean values
                        if (typeof value === 'boolean') {
                              obj[key] = value ? 'Yes' : 'No';
                              continue;
                        }

                        // Handle empty values in objects with some content
                        if (hasNonEmptyValues && (value === '' || value === null || value === undefined)) {
                              obj[key] = '-';
                        }
                  }

                  return obj;
            };

            // Process the entire payload
            return processObject(transformed);
      };

      // The webhook is sent in the handleSubmit function above, specifically here:
      // fetch(WEBHOOK_CONFIG.url, { ... })

      // Determine admin status using centralized helper
      const isSuperAdmin = isAdmin(authUser) || (username && (username === 'superadmin' || username.toLowerCase().includes('admin')));

      return (
            <>
                  <LoadFormModal
                        isOpen={showSavedFormsModal}
                        onClose={() => setShowSavedFormsModal(false)}
                        onSelectForm={loadFormFromMemory}
                        username={username}
                  />
                  <AdminModal
                        isOpen={showAdminModal}
                        onClose={() => setShowAdminModal(false)}
                        currentUser={username}
                        getCurrentFormSnapshot={() => buildFormDataToSave(getSectionName(currentStep))}
                  />
                  <div style={{ display: 'flex', gap: '2rem', padding: '2rem', backgroundColor: 'white' }}>
                        <div style={{ flex: 1 }}>
                              <ModernCard
                                    title={steps.find(s => s.id === currentStep)?.title || 'Form'}
                                    subtitle={steps.find(s => s.id === currentStep)?.subtitle || ''}
                              >
                                    {renderStepContent()}
                                    <div style={{
                                          marginTop: '2rem', paddingTop: '1.5rem',
                                          borderTop: '1px solid #e2e8f0', display: 'flex',
                                          justifyContent: 'space-between', alignItems: 'center'
                                    }}>
                                          <div>
                                                {currentStep > 1 && (
                                                      <button onClick={handlePrevious} style={{
                                                            background: '#6b7280', color: 'white', border: 'none',
                                                            padding: '10px 20px', borderRadius: '6px',
                                                            fontSize: '14px', fontWeight: '500', cursor: 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)', minHeight: '40px',
                                                            transition: 'all 0.2s ease'
                                                      }}>← Previous</button>
                                                )}
                                          </div>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <button onClick={saveFormToMemory} style={{
                                                      background: '#3b82f6', color: 'white', border: 'none',
                                                      padding: '10px 20px', borderRadius: '6px',
                                                      fontSize: '14px', fontWeight: '500', cursor: 'pointer',
                                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)', minHeight: '40px',
                                                      transition: 'all 0.2s ease'
                                                }}>{isSaving ? '💾 Saving...' : '💾 Save'}</button>
                                                <button onClick={() => setShowSavedFormsModal(true)} style={{
                                                      background: '#48bb78', color: 'white', border: 'none',
                                                      padding: '10px 20px', borderRadius: '6px',
                                                      fontSize: '14px', fontWeight: '500', cursor: 'pointer',
                                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)', minHeight: '40px',
                                                      transition: 'all 0.2s ease'
                                                }}>📂 Resume</button>
                                                {isSuperAdmin && (
                                                      <button onClick={() => setShowAdminModal(true)} title="Admin: User Form States" style={{
                                                            background: '#111827', color: 'white', border: 'none',
                                                            padding: '10px 12px', borderRadius: '6px',
                                                            fontSize: '14px', fontWeight: '500', cursor: 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)', minHeight: '40px',
                                                            transition: 'all 0.2s ease'
                                                      }}>⚙️ Admin</button>
                                                )}
                                                {currentStep < steps.length && (
                                                      <button onClick={handleNext} style={{
                                                            background: '#3b82f6', color: 'white', border: 'none',
                                                            padding: '10px 20px', borderRadius: '6px',
                                                            fontSize: '14px', fontWeight: '500', cursor: 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)', minHeight: '40px',
                                                            transition: 'all 0.2s ease'
                                                      }}>Next →</button>
                                                )}
                                                {currentStep === steps.length && (
                                                      <button onClick={handleSubmit} disabled={isSubmitting} style={{
                                                            background: isSubmitting ? '#9ca3af' : '#10b981',
                                                            color: 'white', border: 'none',
                                                            padding: '10px 20px', borderRadius: '6px',
                                                            fontSize: '14px', fontWeight: '500',
                                                            cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)', minHeight: '40px',
                                                            transition: 'all 0.2s ease'
                                                      }}>
                                                            {isSubmitting ? 'Submitting...' : 'Submit Report'} ✓
                                                      </button>
                                                )}
                                          </div>
                                    </div>
                              </ModernCard>
                        </div>
                  </div>
            </>
      );
};

export default ModernMultiStepEventForm;